var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60254 4.70642L8.00014 7.90482L14.3977 4.70642C14.3741 4.29877 14.1954 3.91561 13.8984 3.6354C13.6014 3.35519 13.2085 3.19914 12.8001 3.19922H3.20014C2.79181 3.19914 2.3989 3.35519 2.10188 3.6354C1.80487 3.91561 1.62622 4.29877 1.60254 4.70642Z",
    fill: "#000014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4001 6.49414L8.0001 9.69414L1.6001 6.49414V11.1997C1.6001 11.6241 1.76867 12.0311 2.06873 12.3311C2.36878 12.6312 2.77575 12.7997 3.2001 12.7997H12.8001C13.2244 12.7997 13.6314 12.6312 13.9315 12.3311C14.2315 12.0311 14.4001 11.6241 14.4001 11.1997V6.49414Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ef24e002dd598790f52722835afd1484.svg";
export { ForwardRef as ReactComponent };